export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/components/Home'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/:year/:month/:day/:username',
    name: 'birthday',
    component: () => import('@/components/Birthday/Show'),
    meta: {
      auth: false,
    },
    children: [
      {
        path: 'gift/:giftId',
        name: 'gift',
        component: () => import('@/components/Gift/Show'),
      },
    ],
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/components/Settings'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/setup',
    name: 'setup',
    component: () => import('@/components/Setup'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/components/Login'),
    meta: {
      auth: false,
      skippable: true,
    },
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('@/components/Signup'),
    meta: {
      auth: false,
      skippable: true,
    },
  },
  {
    path: '/password_reset',
    name: 'password_reset',
    component: () => import('@/components/Password/Reset'),
    meta: {
      auth: false,
    },
  },
  {
    path: '/password_new',
    name: 'password_new',
    component: () => import('@/components/Password/New'),
    meta: {
      auth: false,
    },
  },
  {
    path: '/confirmation_resend',
    name: 'confirmation_resend',
    component: () => import('@/components/Confirmation/Resend'),
    meta: {
      auth: false,
    },
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/components/static/NotFound'),
  },
];




// WEBPACK FOOTER //
// ./src/router/index.js